import { React, useState, useEffect } from "react";
import styled from "styled-components";
import { Layout, Table, Button, PageHeader } from "antd";
import {
  RightLayoutContainer,
  OtherPages,
  PageTitleComp,
} from "../styledElements";
import logoCompany from "../../Assets/Images/logo.svg";
import Iconmoon from "../../Components/IconsFiles/icon";
import * as htmlToImage from "html-to-image";
//import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
//import { jsPDF } from "jspdf";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useLocation, useNavigate } from "react-router";
import moment from "moment";
import { getCompanyDetails } from "../../Services/companyServices";
import AlertContainer from "../../Components/AlertBoxes/alertBox";

const PrintData = styled.div`
  padding: 0px;
  margin: 0px;
  background-color: #fff;
  width: 845px;
`;
const ExportHeader = styled.div`
  background-color: #faf9f8;
  width:100%;
  padding: 10px 15px;
  .file-header {
    display: flex;
    justify-content: space-between;
  }
  .file-header-logo {
    width: 130px;
    display: flex;
    img {
      width: 100%;
      align-self: center;
    }
  }
  .client-name {
    width: 25%;
  }
  .client-name h4 {
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    margin: 0px;
  }
  .client-name h6 {
    font-style: italic;
    color: #605e5c;
    font-size: 10px;
    margin: 0px;
  }
  .client-data {
    display: flex;
    > div {
      width: 50%;
      label {
        color: #000;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
      span {
        color: #605e5c;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
    }
  }
`;
const ExportTable = styled.div`
  table {
    width: 100%;
    padding: 10px 15px;
  }
  thead th {
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
  }
  td {
    border-bottom: 1px solid #000;
  }

  th,
  td {
    text-align: left;
    padding: 5px 5px;
    width: 15px;
  }
  th {
    text-transform: uppercase;
    font-size: 10px;
    line-height: 1.2;
    font-weight: 700;
    font-family: var(--sf-pro-text);
  }
  p {
    margin: 0;
    font-family: var(--sf-pro-text);
  }
  .order-d {
    p {
      text-transform: uppercase;
      font-size: 7px;
      font-weight: 600;
    }
    .order-d-l {
      p {
        text-transform: none;
        color: #605e5c;
        font-size: 7px;
        font-weight: 400;
      }
    }
  }
  .date {
    color: #000;
    font-size: 8px;
    font-weight: 600;
  }
  .p-detail {
    font-size: 7px;
    font-weight: 600;
    color: #605e5c;
  }
  .factor {
    color: #000;
    font-size: 7px;
    font-weight: 600;
    font-style: italic;
  }
  .p-ton {
    font-size: 8px;
    font-weight: 600;
    color: #000;
  }
  .reel {
    font-size: 8px;
    color: #605e5c;
    font-style: italic;
  }
  .remark {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 90px;
    line-height: 1.2;
  }
  .address {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 170px;
    line-height: 1.2;
  }
  .ms-2 {
    width: 50px;
  }
  .f-10 {
    font-size: 10px !important;
  }
  .sub-text {
    font-size: 10px;
    color: #605e5c;
  }
  .priority {
    background: #fdf0ef;
  }
`;

function addScript(url) {
  const script = document.createElement("script");
  script.type = "application/javascript";
  script.src = url;
  document.head.appendChild(script);
}
addScript(
  "https://raw.githack.com/eKoopmans/html2pdf/master/dist/html2pdf.bundle.js"
);

const ExportOrdersPdf = (props) => {
  const [showLoader, setLoader] = useState(false);
  const [company, setCompany] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const [orderMangtRecords, setOrderMangtRecords] = useState(location?.state?.orderMangtRecords ? location.state?.orderMangtRecords : []);
  const [deckleOrders, setDeckleOrders] = useState(location?.state?.deckleOrders ? location.state?.deckleOrders : []);
  const [fileName, setFileName] = useState(location?.state?.fileName);
  const [priceDetail, setPriceDetail] = useState(location?.state.priceDetail);
  const [deliveryDetail, setDeliveryDetail] = useState(
    location.state.deliveryDetail
  );
  const currentDate = new Date();
  const today = (currentDate.getDate() + " " + currentDate.toLocaleString("default", { month: "long" }) + "," +  currentDate.getFullYear());

  useEffect(() => {
    setCompanyDetails();
  }, []);

  const setCompanyDetails = () => {
    getCompanyDetails()
      .then((response) => {
        setCompany(response.data);
      })
      .catch((error) => console.log("Error", error));
  };

  const exportHandler = () => {
    let count = deckleOrders?.length? deckleOrders?.length : orderMangtRecords?.length;    
    const input = document.getElementById("export-content");
    html2canvas(input, { height: (window.outerHeight + window.innerHeight) + (150*count),
      windowHeight: (window.outerHeight + window.innerHeight) + (150*count),
      width: (window.outerHeight  + window.innerHeight) - 350,
      windowWidth: (window.outerHeight  + window.innerHeight) - 350,
      scrollY: -window.scrollY }).then(
      (canvas) => {
        // document.getElementById("export-content").appendChild(canvas);
        const image = { type: "jpeg", quality: 0.98 };
        const margin = [0.5, 0.5];
        const filename = "myfile.pdf";

        var imgWidth = 8.5;
        var pageHeight = 11;

        var innerPageWidth = imgWidth - margin[0] * 2;
        var innerPageHeight = pageHeight - margin[1] * 2;

        // Calculate the number of pages.
        var pxFullHeight = canvas.height;
        var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
        var nPages = Math.ceil(pxFullHeight / pxPageHeight);

        // Define pageHeight separately so it can be trimmed on the final page.
        var pageHeight = innerPageHeight;

        // Create a one-page canvas to split up the full image.
        var pageCanvas = document.createElement("canvas");
        var pageCtx = pageCanvas.getContext("2d");
        pageCanvas.width = canvas.width;
        pageCanvas.height = pxPageHeight;

        // Initialize the PDF.
        var pdf = new jsPDF("p", "in", [8.5,11]);
        // var pdf = new jsPDF("landscape");
        for (var page = 0; page < nPages; page++) {
          // Trim the final page to reduce file size.
          if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
            pageCanvas.height = pxFullHeight % pxPageHeight;
            pageHeight =
              (pageCanvas.height * innerPageWidth) / pageCanvas.width;
          }

          // Display the page.
          var w = pageCanvas.width;
          var h = pageCanvas.height;
          pageCtx.fillStyle = "white";
          pageCtx.fillRect(0, 0, w, h);
          pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);
          // Add the page to the PDF.
          if (page > 0) pdf.addPage();
          // debugger;
          var imgData = pageCanvas.toDataURL(
            "image/" + image.type,
            image.quality
          );
          pdf.addImage(
            imgData,
            image.type,
            margin[1],
            margin[0],
            innerPageWidth,
            pageHeight
          );
        }

        pdf.save(fileName+".pdf");
      }
    );
  };
  return (
    <RightLayoutContainer className="export">
      <PageTitleComp className="marginRightAdg ">
      {(deckleOrders.length) ? (
        <PageHeader
          ghost={false}          
          onBack={() => navigate("../order-records/export-orders", {
            state: {
                  body: location?.state?.body,
                  rootPage: location?.state?.rootPage,
                  fileName: location?.state?.fileName,
                  deckleOrders: location?.state?.deckleOrders,
                  exportOrderDetail: location?.state?.exportOrderDetail,
                  switchReelCoreOD: location?.state?.switchReelCoreOD,
                  switchOrderFormat: location?.state?.switchOrderFormat,
                  // switchPlannedWt: location?.state?.switchPlannedWt,
                  // switchPlannedReels: location?.state?.switchPlannedReels,
                  switchPrice: location?.state?.switchPrice,
                  switchAddress: location?.state?.switchAddress,
                  shippingAddress: location?.state?.shippingAddress,
                  billingAddress: location?.state?.billingAddress,
                  switchApprover: location?.state?.switchApprover,
                  switchCreatedBy: location?.state?.switchCreatedBy,
                  switchDeliveryDate: location?.state?.switchDeliveryDate,
                  switchStatus: location?.state?.switchStatus,
                  switchPriority: location?.state?.switchPriority,
                  switchProductName: location?.state?.switchProductName,
                  switchQtyPlanned: location?.state?.switchQtyPlanned,
                  switchPackaging: location?.state?.switchPackaging,
                  switchDiameter: location?.state?.switchDiameter,
                  onBack: true
              },
          })
          }
          title="Deckle Order Records Preview"
          extra={[
            <Button
              key="1"
              className="themeBtn"
              onClick={() => exportHandler()}
            >
              <Iconmoon icon="download" size={17} color="#FFFFFF" />
              Download Deckle Order Records
            </Button>,
          ]}
        ></PageHeader>
        ):( <PageHeader
          ghost={false}          
          onBack={() => 
            navigate(`${location.state.rootPage}/export-orders`, {
              state: {
                  body: location?.state?.body,
                  rootPage: location?.state?.rootPage,
                  fileName: location?.state?.fileName,
                  orderMangtRecords: location?.state?.orderMangtRecords,
                  exportOrderDetail: location?.state?.exportOrderDetail,
                  switchReelCoreOD: location?.state?.switchReelCoreOD,
                  switchOrderFormat: location?.state?.switchOrderFormat,
                  switchPlannedWt: location?.state?.switchPlannedWt,
                  switchPlannedReels: location?.state?.switchPlannedReels,
                  switchPrice: location?.state?.switchPrice,
                  switchAddress: location?.state?.switchAddress,
                  shippingAddress: location?.state?.shippingAddress,
                  billingAddress: location?.state?.billingAddress,
                  switchApprover: location?.state?.switchApprover,
                  switchCreatedBy: location?.state?.switchCreatedBy,
                  switchDeliveryDate: location?.state?.switchDeliveryDate,
                  switchStatus: location?.state?.switchStatus,
                  switchPriority: location?.state?.switchPriority,
                  switchProductName: location?.state?.switchProductName,
                  switchQtyPlanned: location?.state?.switchQtyPlanned,
                  switchPackaging: location?.state?.switchPackaging,
                  switchDiameter: location?.state?.switchDiameter,
                  onBack: true
                },
            })
          }
          title="Order Records Preview"
          extra={[
            <Button
              key="1"
              className="themeBtn"
              onClick={() => exportHandler()}
            >
              <Iconmoon icon="download" size={17} color="#FFFFFF" />
              Download Order Records
            </Button>,
          ]}
        ></PageHeader>            
          )}
      </PageTitleComp>
      <PrintData id="export-content">
        <OtherPages>
          <Layout
            style={{
              backgroundColor: "#ffffff",
            }}
          >
            <div style={{width:"120%", paddingRight:"0%"}}>
              <ExportHeader >
                <div className="file-header" >
                  <div className="file-header-logo">
                    <img src={logoCompany} alt="Kaiznn" />
                  </div>
                  <div className="client-name" style={{position:"relative"}}>
                    {company && <h4>{company.business_name}</h4>}
                    {(deckleOrders.length) ? 
                      (
                        <h6>Deckle Order Records</h6>
                      ): (
                        <h6>Order Records</h6>
                    )}
                    <div className="client-data" >
                      <div> 
                        <label>Number of records</label>
                        {(deckleOrders.length) ? 
                          (
                            <span>{deckleOrders.length}</span>
                          ) : (
                           <span>{orderMangtRecords?.length}</span>
                          )}
                      </div>
                      <div>
                        <label>Date:</label>
                        <span>{today}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </ExportHeader>
              <ExportTable>
                <table>
                  <thead>
                    <tr>
                      <th>ORDER DETAILS</th>
                      <th>PO DATE</th>
                      <th>PARTY</th>
                      <th>PRODUCT DETAILS</th>
                      <th>QUANTITY</th>
                      <th>ORDER DIMENSION (LxW)</th>
                      {location?.state?.switchReelCoreOD && <th>REWINDER DIMENSION</th>}
                      {location?.state?.switchPrice && <th>PRICE</th>}
                      {(location?.state?.switchAddress || location?.state?.switchDeliveryDate) &&<th>DELIVERY INFORMATION</th>}
                      {/* {location?.state?.shippingAddress && <th style={{width:"30px"}}>SHIPPING ADDRESS</th>}
                      {location?.state?.billingAddress && <th style={{width:"30px"}}>BILLING ADDRESS</th>} */}
                      {(location?.state?.shippingAddress || location?.state?.billingAddress) && <th> ADDRESS</th>}
                      {location?.state?.switchCreatedBy && <th>CREATED BY</th>}
                      <th>REMARKS</th>
                    </tr>
                  </thead>
                  {(deckleOrders.length) ? (<tbody>
                      {
                        deckleOrders.map((order) => {
                          return (
                            <tr className={order.priority ? "priority" : ""}>
                              <td>
                                <div>
                                  <p className="p-ton f-10" style={{wordBreak: "break-word"}}>
                                    PO NO.: {order.poNo}
                                  </p>
                                  <p className="p-ton f-10">
                                    GROUP NO.: {order.groupNo}
                                  </p>
                                  <p className="p-ton f-10">
                                    ORDER NO.: {order.orderNo}
                                  </p>
                                  {order.priority && (
                                    <p className="reel f-10">Priority Order</p>
                                  )}
                                  {location?.state?.switchApprover && (
                                    <p className="reel f-10">
                                      Approved By: {order.approvedBy}
                                    </p>
                                  )}
                                  {/* <p className="reel f-10">Produced Reels: {order.produced}</p> */}
                                </div>
                              </td>
                              <td>
                                <p className="p-ton f-10">{order.poDate}</p>
                              </td>
                              <td style={{ width: "30px" }}>
                                <p className="p-ton f-10">Customer:</p>
                                <p className="reel f-10">
                                  {order.customer}
                                </p>
                                <p className="p-ton f-10">Consignee: </p>
                                <p className="reel f-10">{order.consignee}</p>
                              </td>
                              <td>
                              {location?.state?.switchProductName && <p className="p-ton f-10">
                                  {/* {order.productCode} - {order.productName} */}
                                  {order.productName}
                                </p>}
                                <p className="factor f-10">
                                  {order.productSpec}
                                </p>
                              </td>
                              <td>
                                <p className="p-ton f-10">Ordered:</p>
                                {order.orderFormat == "Weight" && (
                                  <p className="reel f-10">
                                    {" "}
                                    {order.orderWeight}
                                  </p>
                                )}
                                {order.orderFormat != "Weight" && (
                                  <p className="reel f-10">
                                    {" "}
                                    {order.orderQuantity} {order.orderFormat}{" "}
                                  </p>
                                )}
                                {(location?.state?.switchPlannedWt ||
                                  location?.state?.switchPlannedReels) && (
                                  <p className="p-ton f-10">Planned:</p>
                                )}
                                {location?.state?.switchPlannedWt && (
                                  <p className="reel f-10">
                                    {order.plannedWeight}
                                  </p>
                                )}
                                {location?.state?.switchPlannedReels && (
                                  <p className="reel f-10">
                                    {parseFloat(order.plannedReels).toFixed(4)}{" "}
                                  </p>
                                )}
                                <p className="p-ton f-10">Pending:</p>
                                <p className="reel f-10">
                                  {order.pendingWeight}
                                </p>
                                <p className="reel f-10">
                                  {parseFloat(order.pendingReels).toFixed(4)} Reels{" "}
                                </p>
                                <p className="p-ton f-10">Produced:</p>
                                {order.orderFormat == "Weight" && (
                                  <p className="reel f-10">
                                    {" "}
                                    {order.processedWeight}
                                  </p>
                                )}
                                {order.orderFormat != "Weight" && (
                                  <p className="reel f-10">
                                    {" "}
                                    {parseFloat(order.processedQuantity).toFixed(4)}{" "}
                                    {order.orderFormat}{" "}
                                  </p>
                                )}
                              </td>
                              <td>
                                <p className="p-ton f-10">
                                  {order.length} x {order.width}
                                </p>
                                <p className="reel f-10">{order.grain}</p>
                              </td>
                              {location?.state?.switchReelCoreOD && (
                                <td>
                                  <p className="p-ton f-10">
                                    Core OD: {order.coreOD}
                                  </p>
                                  <p className="p-ton f-10">
                                    REEL OD: {order.reelOD}
                                  </p>
                                </td>
                              )}
                              {location?.state?.switchPrice && (
                                <td>
                                  <p className="p-ton f-10">
                                    {order.quotedPrice}
                                  </p>
                                  <p className="p-reel f-10">
                                    Net:{order.netPrice}
                                  </p>
                                </td>
                              )}
                              {(location?.state?.switchAddress || location?.state?.switchDeliveryDate) && <td>
                                <p className="p-ton f-10">
                                  Delivery Date: {order.deliveryDate}
                                </p>
                                {/* <p className="p-ton f-10">Customer: {order.customer}</p> */}
                                {location?.state?.switchAddress && (
                                  <>
                                    <p className="p-ton f-10">Address:</p>
                                    <p className="address f-10">
                                      {order.deliveryAddress1}{" "}
                                      {order.deliveryAddress2}
                                      {order.deliveryCity} {order.deliveryState}
                                      -{order.deliveryPincode}
                                    </p>
                                  </>
                                )}
                              </td>}
                              {/* {location?.state?.shippingAddress && <td>
                                <p className="address f-10">{order.shippingAddress1} {order.shippingAddress2}
                                  {order.shippingCity} {order.shippingState}-{order.shippingPincode}
                                  </p>
                              </td>}
                              {location?.state?.billingAddress && <td>
                                <p className="address f-10">{order.billingAddress1} {order.billingAddress2}
                                  {order.billingCity} {order.billingState}-{order.billingPincode}
                                  </p>
                              </td>} */}
                              {(location?.state?.shippingAddress ||
                                location?.state?.billingAddress) && (
                                <td>
                                  {location?.state?.shippingAddress && ( 
                                    <div>
                                    <p className="p-ton f-10">Shipping Address:</p>
                                    <p className="address f-10">
                                      {order.shippingAddress1}{" "}
                                      {order.shippingAddress2}
                                      {order.shippingCity} {order.shippingState}
                                      -{order.shippingPincode}
                                    </p>
                                    </div>
                                  )}

                                  {location?.state?.billingAddress && (
                                    <div style={{marginTop:"4px"}}>
                                    <p className="p-ton f-10">Billing Address:</p>
                                    <p className="address f-10">
                                      {order.billingAddress1}{" "}
                                      {order.billingAddress2}
                                      {order.billingCity} {order.billingState}-
                                      {order.billingPincode}
                                    </p>
                                    </div>
                                  )}
                                </td>
                              )}
                              {location?.state?.switchCreatedBy && (
                                <td>
                                  <p className="p-ton f-10">
                                    {order.createdBy}
                                  </p>
                                </td>
                              )}
                              <td>
                                <p className="p-ton f-10">{order.remarks}</p>
                              </td>
                            </tr>
                          );})
                      }
                    </tbody>) : (<tbody>
                      {
                         orderMangtRecords.map((order) => {
                          return (
                            <tr className={order.priority ? "priority" : ""}>
                              <td >
                                <div>
                                  <p className="p-ton f-10" style={{wordBreak: "break-word"}}>PO NO.: {order.poNo}</p>
                                  <p className="p-ton f-10">GROUP NO.: {order.groupNo}</p>
                                  <p className="p-ton f-10">ORDER NO.: {order.orderNo}</p>
                                  {order.priority && (        
                                  <p className="reel f-10">Priority Order</p>)}
                                  {location?.state?.switchStatus && <p className="reel f-10">Status: {order.status}</p>}
                                  {location?.state?.switchApprover && <p className="reel f-10">Approved By: {order.approvedBy}</p>}
                                  {/* <p className="reel f-10">Produced Reels: {order.produced}</p> */}
                                </div>
                              </td>
                              <td >
                                <p className="p-ton f-10">{order.poDate}</p>
                              </td>
                              <td >
                               <p className="p-ton f-10">Customer:</p>
                               <p className="reel f-10">{order.customerName}</p>
                               <p className="p-ton f-10">Consignee: </p>
                               <p className="reel f-10">{order.consignee}</p>
                              </td>
                              <td >
                                {location?.state?.switchProductName && <p className="p-ton f-10">
                                  {/* {order.productCode} - {order.productName} */}
                                  {order.productName}
                                </p>}
                                <p className="factor f-10">{order.productSpec}</p>
                              </td>
                              <td >
                                <p className="p-ton f-10">Ordered:</p>
                                {order.orderFormat == "Weight" && <p className="reel f-10"> {order.orderWeight}  </p>}
                                {order.orderFormat != "Weight" && <p className="reel f-10"> {order.orderQuantity} {order.orderFormat} </p>} 
                                {(location?.state?.switchPlannedWt || location?.state?.switchPlannedReels) && <p className="p-ton f-10">Planned:</p>}
                                {location?.state?.switchPlannedWt && <p className="reel f-10">{order.plannedWeight}  </p>}
                                {location?.state?.switchPlannedReels && <p className="reel f-10">{order.plannedReels} Reels </p>}
                                <p className="p-ton f-10">Produced:</p>
                                {order.orderFormat == "Weight" && <p className="reel f-10"> {order.processedWeight}  </p>}
                                {order.orderFormat != "Weight" && <p className="reel f-10"> {order.processedQuantity} {order.orderFormat} </p>} 
                              </td>
                              <td >
                                <p className="p-ton f-10">{order.length} x {order.width} </p>
                                <p className="reel f-10">{order.grain}</p>
                              </td>
                              {location?.state?.switchReelCoreOD && <td >
                                <p className="p-ton f-10">Core OD: {order.coreOD}  </p>
                                <p className="p-ton f-10">REEL OD: {order.reelOD}  </p>
                                {/* <p className="reel f-10">Rewinder Reels:{order.rewinderReels}</p> */}

                              </td>}
                              {location?.state?.switchPrice && <td >
                                <p className="p-ton f-10">{order.quotedPrice}</p>
                                <p className="p-reel f-10">Net:{order.netPrice}</p>
                              </td>
                              }
                             {(location?.state?.switchAddress || location?.state?.switchDeliveryDate) && <td >
                              {location?.state?.switchDeliveryDate && <p className="p-ton f-10">Delivery Date: {order.deliveryDate}</p>}
                                {/* <p className="p-ton f-10">Customer: {order.customerName}</p> */}
                                {location?.state?.switchAddress && (
                                <>
                                  <p className="p-ton f-10">Address:</p>
                                  <p className="address f-10">{order.deliveryAddress1} {order.deliveryAddress2}
                                  {order.deliveryCity} {order.deliveryState}-{order.deliveryPincode}
                                  </p>
                               </>
                                )}
                              </td>}
                              {/* {location?.state?.shippingAddress && <td style={{width:"30px"}}>
                                <p className="address f-10">{order.shippingAddress1} {order.shippingAddress2}
                                  {order.shippingCity} {order.shippingState}-{order.shippingPincode}
                                  </p>
                              </td>}
                              {location?.state?.billingAddress && <td style={{width:"30px"}}>
                                <p className="address f-10">{order.billingAddress1} {order.billingAddress2}
                                  {order.billingCity} {order.billingState}-{order.billingPincode}
                                  </p>
                              </td>} */}
                              {(location?.state?.shippingAddress ||
                                location?.state?.billingAddress) && (
                                <td>
                                  {location?.state?.shippingAddress && ( 
                                    <div>
                                    <p className="p-ton f-10">Shipping Address:</p>
                                    <p className="address f-10">
                                      {order.shippingAddress1}{" "}
                                      {order.shippingAddress2}
                                      {order.shippingCity} {order.shippingState}
                                      -{order.shippingPincode}
                                    </p>
                                    </div>
                                  )}

                                  {location?.state?.billingAddress && (
                                    <div style={{marginTop:"4px"}}>
                                    <p className="p-ton f-10">Billing Address:</p>
                                    <p className="address f-10">
                                      {order.billingAddress1}{" "}
                                      {order.billingAddress2}
                                      {order.billingCity} {order.billingState}-
                                      {order.billingPincode}
                                    </p>
                                    </div>
                                  )}
                                </td>
                              )}
                              {location?.state?.switchCreatedBy && 
                                <td >
                                  <p className="p-ton f-10">{order.createdBy}</p>
                                </td>
                              }
                              <td >
                                <p className="p-ton f-10">{order.remarks}</p>
                              </td>
                            </tr>
                          )})
                      }
                      </tbody>
                    )}                  
                  {/* <tbody>
                    {orderRecords.map((order) => {
                      return (
                        <tr className={order.priority ? "priority" : ""}>
                          <td>
                            <div>
                              <p className="p-ton f-10">PO NO.: {order.pono}</p>
                              <p className="p-ton f-10">
                                ORDER NO.: {order.number}
                              </p>
                              {order.priority && (
                                <p className="reel f-10">Priority Order</p>
                              )}
                              <p className="reel f-10">
                                Status: {order.status}
                              </p>
                              <p className="reel f-10">
                                Produced: {order.produced}
                              </p>
                            </div>
                          </td>
                          <td>
                            <p className="p-ton f-10">{order.createdDate}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">
                              {order.product.code} - {order.product.name}
                            </p>
                            <p className="factor f-10">{order.product.spec}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">Planned:</p>
                            <p className="reel f-10">
                              {order.planned.weight} Tonnes
                            </p>
                            <p className="reel f-10">
                              {order.planned.reels} Reels
                            </p>
                            <p className="p-ton f-10">Ordered:</p>
                            <p className="reel f-10">{order.ordered}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">
                              {order.dimension.length
                                ? order.dimension.length
                                : "-"}{" "}
                              x {order.dimension.width} CM
                            </p>
                            <p className="reel f-10">{order.grain}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">
                              Core OD: {order.rewinderDimension.coreID}
                            </p>
                            <p className="p-ton f-10">
                              REEL OD: {order.rewinderDimension.reelOD}
                            </p>
                            <p className="p-reel f-10">
                              Rewinder Reels:{" "}
                              {order.rewinderDimension.rewinderReels}
                            </p>
                          </td>
                          {priceDetail && (
                            <td>
                              <p className="p-ton f-10">
                                ₹ {order.price.quoted}
                              </p>
                              <p className="p-reel f-10">
                                Net: ₹{order.price.net}
                              </p>
                            </td>
                          )}
                          <td>
                            <p className="p-ton f-10">
                              Delivery Date: {order.delivery.date}
                            </p>
                            <p className="p-ton f-10">
                              Customer: {order.customer.name}
                            </p>
                            {deliveryDetail && (
                              <>
                                <p className="p-ton f-10">Address:</p>
                                <p className="address f-10">
                                  {order.delivery.address}
                                </p>
                              </>
                            )}
                          </td>
                          <td>
                            <p className="remark f-10">{order.remarks}</p>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody> */}
                </table>
              </ExportTable>
            </div>
           </Layout>
        </OtherPages>
      </PrintData>
    </RightLayoutContainer>
  );
};
export default ExportOrdersPdf;
